import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessSteps = () => {
  const steps = [
    {
      id: 1,
      icon: "ClipboardList",
      title: "서비스 신청",
      description: "온라인으로 간편하게\n세탁 서비스를 신청하세요"
    },
    {
      id: 2,
      icon: "Truck",
      title: "무료 픽업",
      description: "오전 9시에 문 앞의 신발을\n 수거합니다 (일요일 휴무)"
    },
    {
      id: 3,
      icon: "Sparkles",
      title: "손세탁 케어",
      description: "전용 솔과 용제로\n안전하게 손세탁합니다"
    },
    {
      id: 4,
      icon: "Package",
      title: "무료 배송",
      description: "자연 건조 후 정돈하여 저녁\n 배송합니다 (일요일 휴무)"
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl p-6 sm:p-8">
      <div className="text-center mb-8 sm:mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-3">
          이용 방법
        </h2>
        <p className="text-muted-foreground">
          4단계로 완성되는 간편한 스니커케어
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {steps?.map((step, index) => (
          <div key={step?.id} className="relative">
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="relative">
                <div className="bg-primary/10 p-6 rounded-full">
                  <Icon name={step?.icon} size={32} color="var(--color-primary)" />
                </div>
                <div className="absolute -top-2 -right-2 bg-primary text-primary-foreground w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold">
                  {step?.id}
                </div>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {step?.title}
                </h3>
                <p className="text-sm text-muted-foreground whitespace-pre-line">
                  {step?.description}
                </p>
              </div>
            </div>
            
            {index < steps?.length - 1 && (
              <div className="hidden lg:block absolute top-12 left-full w-full">
                <Icon 
                  name="ArrowRight" 
                  size={24} 
                  color="var(--color-muted-foreground)" 
                  className="absolute left-1/2 -translate-x-1/2"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessSteps;